import iconUrl from '../assets/ask360-icon.png';
import { cn } from '../lib/utils';

/**
 * The ASK360 icon (the logo without its wordmark). The source artwork has an
 * opaque white background and a white robot head, so it can't be made
 * transparent without punching holes in the face — instead it sits on its own
 * white rounded tile, like an app icon, which reads the same on light and dark
 * surfaces. Size it with `className` (e.g. `size-8`).
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'grid shrink-0 place-items-center overflow-hidden rounded-[22%] bg-white ring-1 ring-black/5 dark:ring-white/10',
        className,
      )}
    >
      <img src={iconUrl} alt="" className="block size-full object-contain" draggable={false} />
    </span>
  );
}

/**
 * The wordmark as live text rather than the logo image: "ASK" in the
 * foreground colour, "360" in the logo's cyan→blue→violet gradient
 * (`.brand-gradient`, styles.css). As an image, the logo's dark-navy "ASK"
 * would vanish on the dark theme; as text it's crisp at any size.
 */
export function BrandName({ className }: { className?: string }) {
  return (
    <span className={cn('font-bold tracking-tight text-foreground', className)}>
      ASK<span className="brand-gradient">360</span>
    </span>
  );
}
